import { nanoid } from "nanoid"

import { profileApi } from "../../api/profileApi"

import { addNotification } from "./notificationActions"

import { profileSignal, profileLoadedSignal, profileErrorSignal, profileCcSchemaSignal, profileListSignal, profileListLoadedSignal, profileListErrorSignal } from '../signals/profileSignals.js'

import { NOT_FOUND } from "../../utils/constants"

export const fetchProfileList = async (businessEntityId, config, accessToken, includeChildren = false) => {
    profileListLoadedSignal.value = false
    profileListSignal.value = []
    return await profileApi.fetchProfileList(businessEntityId, config, accessToken, includeChildren).then(
        (profiles) => {
            profileListSignal.value = profiles
            profileListLoadedSignal.value = true
            return profiles
        }
    ).catch(
        (err) => {
            profileListErrorSignal.value = err
            console.log(err)
            addNotification(`Unable to load profiles due to the following error - ${err}`)
        }
    )
}

export const fetchProfile = async (businessEntityId, profileId, config, accessToken) => {
    profileLoadedSignal.value = false
    profileSignal.value = null
    profileCcSchemaSignal.value = null
    return await profileApi.fetchProfile(businessEntityId, profileId, config, accessToken).then(
        (profile) => {
            profileSignal.value = profile
            profileCcSchemaSignal.value = profile?.config?.utgGlobal?.ccschema ? profile.config.utgGlobal.ccschema : NOT_FOUND
            // api interfaces need an id assigned
            profile.config.apiInterfaceConfig?.apiInterface?.map(
                (apiInterface) => {
                    apiInterface.ccid = apiInterface.ccid ? apiInterface.ccid : nanoid()
                }
            )
            profileLoadedSignal.value = true
            return profile
        }
    ).catch(
        (err) => {
            profileErrorSignal.value = err
            console.log(err)
            addNotification(`Unable to load profile due to the following error - ${err}`)
        }
    )
}

export const createProfile = async (businessEntityId, profileConfig, config, accessToken, reload = false) => {
    if (reload) {
        profileListLoadedSignal.value = false
    }
    return await profileApi.createProfile(businessEntityId, profileConfig, config, accessToken).then(
        async (profile) => {
            if (reload) {
                return await fetchProfileList(businessEntityId, config, accessToken).then(
                    () => {
                        return profile
                    }
                )
            }
            return profile
        }
    )
}
export const updateProfile = async (businessEntityId, profileId, profileConfig, config, accessToken, reload = false) => {
    if (reload) {
        profileListLoadedSignal.value = false
    }
    return await profileApi.updateProfile(businessEntityId, profileId, profileConfig, config, accessToken).then(
        async (profile) => {
            profileSignal.value = profile
            if (reload) {
                return await fetchProfileList(businessEntityId, config, accessToken).then(
                    () => {
                        return profile
                    }
                )
            }
            return profile
        }
    )
}
export const deleteProfile = async (businessEntityId, profileId, name, config, accessToken) => {
    profileListLoadedSignal.value = false
    return await profileApi.deleteProfile(businessEntityId, profileId, name, config, accessToken).then(
        async (response) => {
            return await fetchProfileList(businessEntityId, config, accessToken).then(
                () => {
                    return response
                }
            ) 
        }
    )
}
export const applyProfile = async (businessEntityId, profileId, componentIds, config, accessToken) => {
    return await profileApi.applyProfile(businessEntityId, profileId, componentIds, config, accessToken)
}